module.exports = __webpack_public_path__ + "static/media/box.7ae62c73.svg";